import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import {
    FilteredPageQuery,
    IonApiClientService,
    IonToasterService,
    IonLoaderService,
} from 'shared';
import { ITranslationService } from './itranslation.service';

//import { ITranslationService } from './iproductprovider.service';

@Injectable()
// @Injectable({ providedIn: 'root' })
export class TRanslationService implements ITranslationService {
    constructor(
        public _ionApiClientService: IonApiClientService,
        private _ionToasterService: IonToasterService,
        private _ionLoaderService: IonLoaderService
    ) {}

    public getTable(appid: any): Observable<any> {
        return this._ionApiClientService.get<any>(
            'translations/gettable/' + (appid >= 0 ? appid : '')
        );
    }

    public upload_i18(formData: FormData): void {
        this._ionLoaderService.showLoader('');
        this._ionApiClientService
            .post<any>('translations/upload', formData)
            .subscribe((response) => {
                this._ionToasterService.success(
                    'translate.upload-success-addorupdate:' + response.body
                );
            });
    }

    public saveTranslation(translation: any): Observable<any> {
        return this._ionApiClientService.post<any>('translations/save', translation).pipe(
            map((response) => {
                return response.body;
            })
        );
    }

    public deleteTranslation(translation: any): Observable<any> {
        return this._ionApiClientService
            .post<any>('translations/delete', translation)
            .pipe(
                map((response) => {
                    return response.body;
                })
            );
    }

    public getTargetList(): Observable<any> {
        return this._ionApiClientService.get<any>('translations/getTargetList', null);
    }

    public publish(targets: any[]): Observable<any> {
        return this._ionApiClientService.post<any>('translations/publish', targets).pipe(
            map((response) => {
                return response.body;
            })
        );
    }

    public getCategories(appid: any): Observable<any> {
        return this._ionApiClientService.get<any>(
            'translations/getCategories/' + (appid >= 0 ? appid : ''),
            null
        );
    }

    //public uploadPhoto(uploadPhotoDTO: UploadPhotoDTO): Observable<any> {
    //  return this._ionApiClientService.post<UploadPhotoDTO>(
    //    'productprovider/upload-photo',
    //    uploadPhotoDTO,
    //    null,
    //    'Uploading photo',
    //    false,
    //    'common.upload-success'
    //  );
    //}
}
